import { FIELD_REANNOTATION_FIELDS } from "@shared/types/corpus";
import type { FieldAnnotationState, FieldReannotationField } from "../../../../../lib/corpusApi";
import { fieldLabel } from "../../../../../lib/scorecardFieldUtils";

/** Display name of a scorecard field a field_reannotation job can re-annotate. */
export function fieldReannotationFieldLabel(field: FieldReannotationField): string {
  return fieldLabel(field);
}

export interface FieldReannotationFieldOption {
  value: FieldReannotationField;
  label: string;
}

export const FIELD_REANNOTATION_FIELD_OPTIONS: FieldReannotationFieldOption[] =
  FIELD_REANNOTATION_FIELDS.map((value) => ({ value, label: fieldReannotationFieldLabel(value) }));

export interface FieldAnnotationStateOption {
  value: FieldAnnotationState;
  label: string;
}

export const FIELD_ANNOTATION_STATE_OPTIONS: FieldAnnotationStateOption[] = [
  { value: "any", label: "Any" },
  { value: "human", label: "Human validated (approved, overridden or set by a person)" },
  { value: "non_human", label: "Not human validated (AI suggested or no label)" },
  { value: "ai", label: "AI suggested (in review or auto-approved)" },
  { value: "missing", label: "No label" },
];
